import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	termsInDays: {
		id: 'sisu.totalDueToday.termsInDays',
		defaultMessage:
			'{duration} {quantity, plural, one {day} other {days}} free, then {monthly}/month, billed annually at {yearly}/year. <cancelAnytimeLink>Cancel anytime</cancelAnytimeLink>.',
		description: 'Terms for the Total Due Today for a trial duration in days',
	},
	termsInMonths: {
		id: 'sisu.totalDueToday.termsInMonths',
		defaultMessage:
			'{duration} {quantity, plural, one {month} other {months}} free, then {monthly}/month, billed annually at {yearly}/year. <cancelAnytimeLink>Cancel anytime</cancelAnytimeLink>.',
		description: 'Terms for the Total Due Today for a trial duration in months',
	},
});
